// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3233":"25e9444b","3575":"ce044c50","4425":"25e9444b","4935":"08d55499","6247":"25e9444b","9347":"25e9444b"}[chunkId] + ".chunk.css";
};